export default __webpack_public_path__ + "static/media/imgDarkEn3.72d482e1.png";